define('app/sdc/not/serializable/sdc-not-serializable-factory',[],function () {
	return sdcNotEnumerableFactory;
	function sdcNotEnumerableFactory(values, serializableValues) {
		if (!angular.isObject(values)) {
			return values;
		}
		var isArray = angular.isArray(values),
			newObj = isArray ? [] : Object.create(Object.getPrototypeOf(values));
		for (var prop in values) {
			if (!values.hasOwnProperty(prop)) {
				continue;
			}
			if (isArray) {
				var intProp = Number.parseInt(prop);
				// Check if the property is numeric, if it is that means it's an item in the
				// array so we want to avoid the Object.defineProperty mechanism
				if (intProp >= 0 && intProp == prop) {
					newObj[prop] = values[prop];
				}
				continue;
			}
			Object.defineProperty(newObj, prop, {
				configurable: true,
				enumerable: false,
				writable: true,
				value: values[prop]
			});
		}
		if (arguments.length > 1) {
			angular.extend(newObj, serializableValues);
		}
		return newObj;
	}

});
